import { render, staticRenderFns } from "./SharerBillingIssues.vue?vue&type=template&id=56d0bdae&scoped=true"
import script from "./SharerBillingIssues.vue?vue&type=script&lang=js"
export * from "./SharerBillingIssues.vue?vue&type=script&lang=js"
import style0 from "./SharerBillingIssues.vue?vue&type=style&index=0&id=56d0bdae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d0bdae",
  null
  
)

export default component.exports